import React from "react";
import cookieManager from "../components/CookieManager";
import Constants from "../components/Constants";
import {ENV} from "../env";

const withWhitelist = (WrappedComponent) => {
    return class extends React.Component {
        state = {
            isWhitelisted: false,
            loading: true,
        };

        async componentDidMount() {
            try {
                const response = await fetch("https://s3.eu-west-1.amazonaws.com/frontend.assets.tangelogames.app/config/skills/whitelist-skills.json");
                const data = await response.json();
                const skillsId = cookieManager.get(Constants.SKILLS_ID);

                const isWhitelisted = skillsId && data.whitelist.includes(skillsId);

                console.log("[WHITELIST] skillsId:", skillsId, "isWhitelisted:", isWhitelisted);

                this.setState({ isWhitelisted, loading: false });
            } catch (error) {
                console.error("[WHITELIST] Error fetching whitelist:", error);
                this.setState({ loading: false });
            }
        }

        render() {
            const { isWhitelisted, loading } = this.state;

            // Use whitelist only on default environment
            if (loading || (!isWhitelisted && ENV === "default")) {
                return null;
            }

            return <WrappedComponent {...this.props} />;
        }
    };
};

export default withWhitelist;
